import React from 'react';
import AppBaseComponent from '../../../components/AppBaseComponent';
import { connect } from 'react-redux';
import DateService from '../../../services/DateService';

class StepsDetailTableFields extends AppBaseComponent {
    constructor(props) {
        super(props);
    }

    fieldName   =   (field)  => {
        switch (field) {
            case 'receiver_name':
                return {key : field, value: 'Receiver Name' };
            case 'total_cost':
                return {key : field, value:  'Total Cost'};
            case 'boe_number':
                return {key : field, value: 'BOE Number'};
            case 'material_description':
                return {key : field, value: 'Machinery/Material Description'};
            case 'eway_bill_number':
                return {key : field, value: 'Eway bill Number'};
            case 'consigment_number':
                return {key : field, value: 'Consignment Number'};
            // case 'booking_place':
            //     return {key : field, value: 'Booking Place'};
            case 'invoice_value':
                return {key : field, value: 'Invoice Value'};
            case 'vehicle_number':
                return {key : field, value: 'Vehicle Number'};
            case 'no_of_boxes':
                return {key : field, value: 'No. of Boxes'};
            case 'driver_contact_number':
                return {key : field, value: 'Driver Contact Number'};
            case 'driver_name':
                return {key : field, value: 'Driver Name'};
            case 'invoice_number':
                return {key : field, value: 'Invoice Number'};
            case 'date_of_requirement':
                return {key : field, value: 'Date of Requirement'};
            case 'date_of_dispatch':
                return {key : field, value: 'Date of Dispatch'}; 
            case 'expected_delivery_date':
                return {key : field, value: 'Expected Delivery Date'};
            case 'delivery_date_at_godown':
                return {key : field, value: 'Delivery Date at Godown'};
            case 'delivery_date_at_site':
                return {key : 'delivery_date_at_site', value: 'Delivery Date at Site'};
            case 'invoice_date':
                return {key : field, value: 'Invoice Date'};
            case 'payment_date':
                return {key : field, value: 'Payment Date'};
            case 'load_description':
                return {key : 'load_description', value: 'Load Description'};  
            case 'priority': 
                return {key: 'priority', value: 'Priority'};
            case 'material_type':
                return {key: 'material_type', value: 'Material Type'};
            case 'consignment_type':
                return {key: 'consignment_type', value: 'Consignment Type'};
            default:
                return {key : '', value: ''};
        }
    }

    render () {
        const {logisticViewData, field, originType, origin_type_detail, destinationType, destination_type_detail} = this.props;
        const {key, value}  =   this.fieldName(field);

        return (
            <>
            {
                field ===  "logistic_type" && 
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Logistic Type</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.logistic_type ? logisticViewData.logistic_type : ''}</td>
                </tr>
            }
            {
                field ===  "division" && 
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Division</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.division_name ? logisticViewData.division_name : ''}</td>  
                </tr>
            }
            {/* 'load_dimensions', */}
            {
                ['type_of_vehicle', 'priority', 'load_description', 'material_type', 'consignment_type'].includes(field) && value &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>{value}</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData[key] ? logisticViewData[key] : ''}</td>  
                </tr>
            }
            {
                ['delivery_date_at_godown', 'delivery_date_at_site', 'date_of_requirement'].includes(field) && value &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>{value}</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData[key] ? DateService.dateTimeFormat(logisticViewData[key], 'DD-MMM-YYYY') : ''}</td>  
                </tr>
            }
            {
                field === 'load_dimensions' && 
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Load Dimensions</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.load_dimensions ? `Length: ${logisticViewData.load_dimensions.l ?? ''} Width: ${logisticViewData.load_dimensions.w ?? ''} Hight: ${logisticViewData.load_dimensions.h ?? ''}` : ''}</td>  
                </tr>
            }
            {
                field ===  "origin_type" && 
                <>
                    <tr>
                        <td className="fs14 fw-normal" style={{ "width": "30%" }}>{originType}</td>
                        <td className="fs14 fw500" style={{ "width": "70%" }}>{origin_type_detail}</td>
                    </tr>
                    <tr>
                        <td className="fs14 fw-normal" style={{ "width": "30%" }}>Address</td>
                        <td className="fs14 fw500" style={{ "width": "70%" }}>
                            {
                                logisticViewData.display_origin_address 
                                ? 
                                `${logisticViewData.display_origin_address.address1 ? logisticViewData.display_origin_address.address1 + ", " : ""}${logisticViewData.display_origin_address.address2 ? logisticViewData.display_origin_address.address2 + ", " : ""}${logisticViewData.display_origin_address.landmark ? logisticViewData.display_origin_address.landmark + ", " : ""}${logisticViewData.display_origin_address.city ? logisticViewData.display_origin_address.city + ", " : ""}${logisticViewData.display_origin_address.country ? logisticViewData.display_origin_address.country + ", " : ""}${logisticViewData.display_origin_address.state ? logisticViewData.display_origin_address.state + ", " : ""}${logisticViewData.display_origin_address.district ? logisticViewData.display_origin_address.district + ", " : ""}${logisticViewData.display_origin_address.pincode ? logisticViewData.display_origin_address.pincode + ", " : ""}`
                                :
                                ''
                            }
                        </td>
                    </tr>

                </>
            }
            {
                field ===  "destination" && 
                <>
                    <tr>
                        <td className="fs14 fw-normal" style={{ "width": "30%" }}>{destinationType}</td>
                        <td className="fs14 fw500" style={{ "width": "70%" }}>{destination_type_detail}</td>
                    </tr>
                    <tr>
                        <td className="fs14 fw-normal" style={{ "width": "30%" }}>Address</td>
                        <td className="fs14 fw500" style={{ "width": "70%" }}>
                            {
                                logisticViewData.display_destination_address 
                                ?
                                `${logisticViewData.display_destination_address.address1 ? logisticViewData.display_destination_address.address1 + ", " : ""}${logisticViewData.display_destination_address.address2 ? logisticViewData.display_destination_address.address2 + ", " : ""}${logisticViewData.display_destination_address.landmark ? logisticViewData.display_destination_address.landmark + ", " : ""}${logisticViewData.display_destination_address.city ? logisticViewData.display_destination_address.city + ", " : ""}${logisticViewData.display_destination_address.country ? logisticViewData.display_destination_address.country + ", " : ""}${logisticViewData.display_destination_address.state ? logisticViewData.display_destination_address.state + ", " : ""}
                                ${logisticViewData.display_destination_address.district ? logisticViewData.display_destination_address.district + ", " : ""}${logisticViewData.display_destination_address.pincode ? logisticViewData.display_destination_address.pincode + ", " : ""}`
                                :
                                ''
                            }
                        </td>
                    </tr>
                </>
            }
            {
                field ===  "date_of_dispatch"  &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Date of Dispatch</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.dispatch_date ? DateService.dateTimeFormat(logisticViewData.dispatch_date, 'DD-MMM-YYYY') : ''}</td>
                </tr>
            }
            {
                field ===  "expected_delivery_date"  &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Expected Delivery Date</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.delivery_date ? DateService.dateTimeFormat(logisticViewData.delivery_date, 'DD-MMM-YYYY') : ''}</td>
                </tr>
            }
            {
                field ===  "transport_days" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Transport Days</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.transport_days ? logisticViewData.transport_days : ''}</td>
                </tr>
            }
            {
                field ===  "receiver_name" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Receiver Name</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.receiver_name}</td>
                </tr>
            }
            {
                field ===  "type_of_load" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Type of Load</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>
                        {logisticViewData.load_type ? logisticViewData.load_type : ''}
                    </td>
                </tr>
            }
            {
                field ===  "consigment_number" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Consigment Number</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.consigment_number ? logisticViewData.consigment_number : ''}</td>
                </tr>
            }
            {
                field ===  "booking_place" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Booking Place</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.booking_place ? logisticViewData.booking_place : ''}</td>
                </tr>
            } 
            {
                field ===  "transporter_name" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Courier/Transporter Name</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.transporter_name ? logisticViewData.transporter_name : ''}</td>
                </tr>
            } 
            {
                field ===  "vehicle_number" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Vehicle Number</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.vehicle_number ? logisticViewData.vehicle_number : ''}</td>
                </tr>
            } 
            {
                field ===  "weight" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Weight</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.weight ? logisticViewData.weight : ''} {logisticViewData.unit_of_measurement}</td>
                </tr>
            } 
            {
                field ===  "no_of_boxes" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>No. of Boxes</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.number_of_boxes ? logisticViewData.number_of_boxes : ''}</td>
                </tr>
            } 
            {
                field ===  "driver_name" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Driver Name</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.driver_name ? logisticViewData.driver_name : ''}</td>
                </tr>
            } 
            {
                field ===  "driver_contact_number" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Driver Contact Number</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.driver_contact_number ? logisticViewData.driver_contact_number : ''}</td>
                </tr>
            } 
            {
                field ===  "invoice_number" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Invoice Number</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.gst_invoice_number ? logisticViewData.gst_invoice_number : ''}</td>
                </tr>
            } 
            {
                field ===  "invoice_date" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Invoice Date</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.invoice_date ? DateService.dateTimeFormat(logisticViewData.invoice_date, 'DD-MMM-YYYY') : ''}</td>
                </tr>
            } 
            {
                field ===  "invoice_value" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Invoice Value</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.invoice_value ? logisticViewData.invoice_value : ''}</td>
                </tr>
            } 
            {
                field ===  "eway_bill_number" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Eway Bill Number</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.eway_bill_number ? logisticViewData.eway_bill_number : ''}</td>
                </tr>
            } 
            {
                field ===  "payment_mode" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Payment Mode</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }} >{logisticViewData.payment_mode ? logisticViewData.payment_mode : ''}</td>
                </tr>
            } 
            {
                field ===  "payment_date" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Payment Date</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }} >{logisticViewData.payment_date ? DateService.dateTimeFormat(logisticViewData.payment_date, 'DD-MMM-YYYY') : ''}</td>
                </tr>
            } 
            {
                field ===  "material_description" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Machinery/Material Description</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.machinery_description ? logisticViewData.machinery_description : ''}</td>
                </tr>
            }
            {
                field ===  "cnf_agent" && logisticViewData.logistic_type === "International" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>CHA Agent</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.cnfAgent_name ? logisticViewData.cnfAgent_name : ''}</td>
                </tr>
            } 
            {
                field ===  "material_handler_name" && logisticViewData.logistic_type === "International" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>Freight Forwarder Name</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.handler_name ? logisticViewData.handler_name : ''}</td>
                </tr>
            }
            {
                field ===  "boe_number" && logisticViewData.logistic_type === "International" &&
                <tr>
                    <td className="fs14 fw-normal" style={{ "width": "30%" }}>BOE Number</td>
                    <td className="fs14 fw500" style={{ "width": "70%" }}>{logisticViewData.boe_number ? logisticViewData.boe_number : ''}</td>
                </tr>
            }
            </>
        )
    }
}




const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(StepsDetailTableFields);